// Отдельный модуль ради порядка: импорты выполняются раньше тела index.tsx,
// а подмена хранилища нужна до того, как его прочтёт любой другой модуль
import { installImpersonation } from './impersonation';

installImpersonation();
